module.exports = __webpack_public_path__ + "media/chaoliu.8a9990fa.mp3";